module.exports = __webpack_public_path__ + "img/pic_no goods@2x.3567fbc4.png";